import { Client } from 'app/shared/models/client.model';
import { IsiClientReportDetail } from './../isi-report-detail/isi-report-detail.model';
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'display-client-report',
  templateUrl: './display-client-report.component.html',
  styleUrls: ['./display-client-report.component.css'],
})
export class DisplayClientReportComponent {

  @Input()
  reportData: IsiClientReportDetail;

  @Input()
  listName: string;
  constructor() { }

  toggleList(reportData: IsiClientReportDetail) {
    this.reportData.open = !reportData.open;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/display-client-report/display-client-report.component.ts